import {
	ApolloClient,
	InMemoryCache,
	HttpLink,
	ApolloLink,
} from '@apollo/client';
import { APPMAKER_GQL_URL } from '@appmaker/core/api/core';
import { setContext } from '@apollo/client/link/context';
import { tokenManager } from './services/tokenManager';
import { createBuildOnlyFetch } from './services/buildOnlyApiPolicy';

const httpLink = new HttpLink({
	uri: APPMAKER_GQL_URL,
	fetch: createBuildOnlyFetch((...args) => fetch(...args)),
	fetchOptions: {
		credentials: 'include',
	},
});

const customHeaderMiddleware = setContext(async (_, { headers }) => {
	let customHeader = {};
	// Get session token from token manager (initialized by AppBridgeAuthInjector)
	if (tokenManager.isInitialized()) {
		try {
			const token = await tokenManager.getToken();
			if (token) {
				customHeader['Authorization'] = `Bearer ${token}`;
			}
		} catch (error) {
			console.log('Unable to get shopify token', error);
		}
	}
	return {
		headers: {
			...headers,
			...customHeader,
		},
	};
});

const link = ApolloLink.from([customHeaderMiddleware, httpLink]);
const client = new ApolloClient({
	link: link,
	credentials: 'include',
	cache: new InMemoryCache(),
});

export default client;
